
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as billVh8np08wwPMeta } from "/vercel/path0/pages/bill.vue?macro=true";
import { default as confirm_45email_45v3NZ41YQh8TvMeta } from "/vercel/path0/pages/confirm-email-v3.vue?macro=true";
import { default as confirm_45emailzCr8rC42rFMeta } from "/vercel/path0/pages/confirm-email.vue?macro=true";
import { default as mental_45sideCNVXuDfsNUMeta } from "/vercel/path0/pages/courses/mental-side.vue?macro=true";
import { default as sexologyH03EIjepWnMeta } from "/vercel/path0/pages/courses/sexology.vue?macro=true";
import { default as super_45pricebrVDDjzjsdMeta } from "/vercel/path0/pages/courses/super-price.vue?macro=true";
import { default as downloadhJvQzgwFZcMeta } from "/vercel/path0/pages/download.vue?macro=true";
import { default as final_45pageIWJVhkTa5FMeta } from "/vercel/path0/pages/final-page.vue?macro=true";
import { default as basic_45discountXhGjgMii2cMeta } from "/vercel/path0/pages/fitness/basic-discount.vue?macro=true";
import { default as did_45you_45knowemkMmqegDoMeta } from "/vercel/path0/pages/fitness/did-you-know.vue?macro=true";
import { default as super_45discountuIryNVlQd7Meta } from "/vercel/path0/pages/fitness/super-discount.vue?macro=true";
import { default as landing_emailIOrt1ZPhFJMeta } from "/vercel/path0/pages/landing_email.vue?macro=true";
import { default as landing_v12_2blv1jIyVBfMeta } from "/vercel/path0/pages/landing_v12_2.vue?macro=true";
import { default as landing_v126BSrM0XGxvMeta } from "/vercel/path0/pages/landing_v12.vue?macro=true";
import { default as landing_45paddlen1Co23q0caMeta } from "/vercel/path0/pages/landing-paddle.vue?macro=true";
import { default as landing_45v16SFR2UePtQ4Meta } from "/vercel/path0/pages/landing-v16.vue?macro=true";
import { default as landing_45v17UdrDpvVFokMeta } from "/vercel/path0/pages/landing-v17.vue?macro=true";
import { default as landingIrNCINQjz2Meta } from "/vercel/path0/pages/landing.vue?macro=true";
import { default as plp_451LB5Zhf7QHlMeta } from "/vercel/path0/pages/plp-1.vue?macro=true";
import { default as plp_4510r3FQPePFHNMeta } from "/vercel/path0/pages/plp-10.vue?macro=true";
import { default as plp_452zpB1dNhubSMeta } from "/vercel/path0/pages/plp-2.vue?macro=true";
import { default as plp_453RnFwoJCIyzMeta } from "/vercel/path0/pages/plp-3.vue?macro=true";
import { default as plp_454sx2Rvq0KX7Meta } from "/vercel/path0/pages/plp-4.vue?macro=true";
import { default as plp_455Z7g56UmEPgMeta } from "/vercel/path0/pages/plp-5.vue?macro=true";
import { default as plp_45681uqM5EFBJMeta } from "/vercel/path0/pages/plp-6.vue?macro=true";
import { default as plp_457MCRdHMjwLDMeta } from "/vercel/path0/pages/plp-7.vue?macro=true";
import { default as plp_458kDVKuwNKTQMeta } from "/vercel/path0/pages/plp-8.vue?macro=true";
import { default as plp_4592ZSYZpAflgMeta } from "/vercel/path0/pages/plp-9.vue?macro=true";
import { default as effective_45exercisesTnRDLqkrCxMeta } from "/vercel/path0/pages/quiz/[id]/effective-exercises.vue?macro=true";
import { default as goalsjynoDekJE6Meta } from "/vercel/path0/pages/quiz/[id]/goals.vue?macro=true";
import { default as intermediateGirFWSkZOOMeta } from "/vercel/path0/pages/quiz/[id]/intermediate.vue?macro=true";
import { default as kegel_45effectivenessO202F41S22Meta } from "/vercel/path0/pages/quiz/[id]/kegel-effectiveness.vue?macro=true";
import { default as kegel_45plan_45benefitsBbKtz11SsPMeta } from "/vercel/path0/pages/quiz/[id]/kegel-plan-benefits.vue?macro=true";
import { default as pp1iP6bVcUzwVMeta } from "/vercel/path0/pages/quiz/[id]/pp1.vue?macro=true";
import { default as questioniDzzxauEwhMeta } from "/vercel/path0/pages/quiz/[id]/question.vue?macro=true";
import { default as rateZyiCc25rCRMeta } from "/vercel/path0/pages/quiz/[id]/rate.vue?macro=true";
import { default as s1Entsh68v4cMeta } from "/vercel/path0/pages/quiz/[id]/s1.vue?macro=true";
import { default as score_45ratePvr81gx3DnMeta } from "/vercel/path0/pages/quiz/[id]/score-rate.vue?macro=true";
import { default as analyzing_45answers5yivgXoqssMeta } from "/vercel/path0/pages/quiz/analyzing-answers.vue?macro=true";
import { default as creating_45planOushZ54F7sMeta } from "/vercel/path0/pages/quiz/creating-plan.vue?macro=true";
import { default as final_45adjustment_45v3GUylvFiVRqMeta } from "/vercel/path0/pages/quiz/final-adjustment-v3.vue?macro=true";
import { default as final_45adjustment5kuQrijrFPMeta } from "/vercel/path0/pages/quiz/final-adjustment.vue?macro=true";
import { default as health_45onboardingKJefKDhT3oMeta } from "/vercel/path0/pages/quiz/health-onboarding.vue?macro=true";
import { default as help_45improveYcFETMurRBMeta } from "/vercel/path0/pages/quiz/help-improve.vue?macro=true";
import { default as score_45onboardingcMAyaSzdXyMeta } from "/vercel/path0/pages/quiz/score-onboarding.vue?macro=true";
import { default as score_45your_45resultHh1q1PpGqlMeta } from "/vercel/path0/pages/quiz/score-your-result.vue?macro=true";
import { default as the_45best_45thingZNnyX98OYuMeta } from "/vercel/path0/pages/quiz/the-best-thing.vue?macro=true";
import { default as trusted5VH0ISQ610Meta } from "/vercel/path0/pages/quiz/trusted.vue?macro=true";
import { default as indexDq5y7eD1iXMeta } from "/vercel/path0/pages/score/index.vue?macro=true";
import { default as verify_45emailTib6n1igWMMeta } from "/vercel/path0/pages/verify-email.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "bill___en",
    path: "/en/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___es",
    path: "/es/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___es-mx",
    path: "/es-mx/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___pt",
    path: "/pt/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___pt-br",
    path: "/pt-br/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___de",
    path: "/de/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___fr",
    path: "/fr/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___it",
    path: "/it/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "confirm-email-v3___en",
    path: "/en/confirm-email-v3",
    meta: confirm_45email_45v3NZ41YQh8TvMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email-v3.vue")
  },
  {
    name: "confirm-email-v3___es",
    path: "/es/confirm-email-v3",
    meta: confirm_45email_45v3NZ41YQh8TvMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email-v3.vue")
  },
  {
    name: "confirm-email-v3___es-mx",
    path: "/es-mx/confirm-email-v3",
    meta: confirm_45email_45v3NZ41YQh8TvMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email-v3.vue")
  },
  {
    name: "confirm-email-v3___pt",
    path: "/pt/confirm-email-v3",
    meta: confirm_45email_45v3NZ41YQh8TvMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email-v3.vue")
  },
  {
    name: "confirm-email-v3___pt-br",
    path: "/pt-br/confirm-email-v3",
    meta: confirm_45email_45v3NZ41YQh8TvMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email-v3.vue")
  },
  {
    name: "confirm-email-v3___de",
    path: "/de/confirm-email-v3",
    meta: confirm_45email_45v3NZ41YQh8TvMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email-v3.vue")
  },
  {
    name: "confirm-email-v3___fr",
    path: "/fr/confirm-email-v3",
    meta: confirm_45email_45v3NZ41YQh8TvMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email-v3.vue")
  },
  {
    name: "confirm-email-v3___it",
    path: "/it/confirm-email-v3",
    meta: confirm_45email_45v3NZ41YQh8TvMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email-v3.vue")
  },
  {
    name: "confirm-email___en",
    path: "/en/confirm-email",
    meta: confirm_45emailzCr8rC42rFMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___es",
    path: "/es/confirm-email",
    meta: confirm_45emailzCr8rC42rFMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___es-mx",
    path: "/es-mx/confirm-email",
    meta: confirm_45emailzCr8rC42rFMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___pt",
    path: "/pt/confirm-email",
    meta: confirm_45emailzCr8rC42rFMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___pt-br",
    path: "/pt-br/confirm-email",
    meta: confirm_45emailzCr8rC42rFMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___de",
    path: "/de/confirm-email",
    meta: confirm_45emailzCr8rC42rFMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___fr",
    path: "/fr/confirm-email",
    meta: confirm_45emailzCr8rC42rFMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___it",
    path: "/it/confirm-email",
    meta: confirm_45emailzCr8rC42rFMeta || {},
    component: () => import("/vercel/path0/pages/confirm-email.vue")
  },
  {
    name: "courses-mental-side___en",
    path: "/en/courses/mental-side",
    meta: mental_45sideCNVXuDfsNUMeta || {},
    component: () => import("/vercel/path0/pages/courses/mental-side.vue")
  },
  {
    name: "courses-mental-side___es",
    path: "/es/courses/mental-side",
    meta: mental_45sideCNVXuDfsNUMeta || {},
    component: () => import("/vercel/path0/pages/courses/mental-side.vue")
  },
  {
    name: "courses-mental-side___es-mx",
    path: "/es-mx/courses/mental-side",
    meta: mental_45sideCNVXuDfsNUMeta || {},
    component: () => import("/vercel/path0/pages/courses/mental-side.vue")
  },
  {
    name: "courses-mental-side___pt",
    path: "/pt/courses/mental-side",
    meta: mental_45sideCNVXuDfsNUMeta || {},
    component: () => import("/vercel/path0/pages/courses/mental-side.vue")
  },
  {
    name: "courses-mental-side___pt-br",
    path: "/pt-br/courses/mental-side",
    meta: mental_45sideCNVXuDfsNUMeta || {},
    component: () => import("/vercel/path0/pages/courses/mental-side.vue")
  },
  {
    name: "courses-mental-side___de",
    path: "/de/courses/mental-side",
    meta: mental_45sideCNVXuDfsNUMeta || {},
    component: () => import("/vercel/path0/pages/courses/mental-side.vue")
  },
  {
    name: "courses-mental-side___fr",
    path: "/fr/courses/mental-side",
    meta: mental_45sideCNVXuDfsNUMeta || {},
    component: () => import("/vercel/path0/pages/courses/mental-side.vue")
  },
  {
    name: "courses-mental-side___it",
    path: "/it/courses/mental-side",
    meta: mental_45sideCNVXuDfsNUMeta || {},
    component: () => import("/vercel/path0/pages/courses/mental-side.vue")
  },
  {
    name: "courses-sexology___en",
    path: "/en/courses/sexology",
    meta: sexologyH03EIjepWnMeta || {},
    component: () => import("/vercel/path0/pages/courses/sexology.vue")
  },
  {
    name: "courses-sexology___es",
    path: "/es/courses/sexology",
    meta: sexologyH03EIjepWnMeta || {},
    component: () => import("/vercel/path0/pages/courses/sexology.vue")
  },
  {
    name: "courses-sexology___es-mx",
    path: "/es-mx/courses/sexology",
    meta: sexologyH03EIjepWnMeta || {},
    component: () => import("/vercel/path0/pages/courses/sexology.vue")
  },
  {
    name: "courses-sexology___pt",
    path: "/pt/courses/sexology",
    meta: sexologyH03EIjepWnMeta || {},
    component: () => import("/vercel/path0/pages/courses/sexology.vue")
  },
  {
    name: "courses-sexology___pt-br",
    path: "/pt-br/courses/sexology",
    meta: sexologyH03EIjepWnMeta || {},
    component: () => import("/vercel/path0/pages/courses/sexology.vue")
  },
  {
    name: "courses-sexology___de",
    path: "/de/courses/sexology",
    meta: sexologyH03EIjepWnMeta || {},
    component: () => import("/vercel/path0/pages/courses/sexology.vue")
  },
  {
    name: "courses-sexology___fr",
    path: "/fr/courses/sexology",
    meta: sexologyH03EIjepWnMeta || {},
    component: () => import("/vercel/path0/pages/courses/sexology.vue")
  },
  {
    name: "courses-sexology___it",
    path: "/it/courses/sexology",
    meta: sexologyH03EIjepWnMeta || {},
    component: () => import("/vercel/path0/pages/courses/sexology.vue")
  },
  {
    name: "courses-super-price___en",
    path: "/en/courses/super-price",
    meta: super_45pricebrVDDjzjsdMeta || {},
    component: () => import("/vercel/path0/pages/courses/super-price.vue")
  },
  {
    name: "courses-super-price___es",
    path: "/es/courses/super-price",
    meta: super_45pricebrVDDjzjsdMeta || {},
    component: () => import("/vercel/path0/pages/courses/super-price.vue")
  },
  {
    name: "courses-super-price___es-mx",
    path: "/es-mx/courses/super-price",
    meta: super_45pricebrVDDjzjsdMeta || {},
    component: () => import("/vercel/path0/pages/courses/super-price.vue")
  },
  {
    name: "courses-super-price___pt",
    path: "/pt/courses/super-price",
    meta: super_45pricebrVDDjzjsdMeta || {},
    component: () => import("/vercel/path0/pages/courses/super-price.vue")
  },
  {
    name: "courses-super-price___pt-br",
    path: "/pt-br/courses/super-price",
    meta: super_45pricebrVDDjzjsdMeta || {},
    component: () => import("/vercel/path0/pages/courses/super-price.vue")
  },
  {
    name: "courses-super-price___de",
    path: "/de/courses/super-price",
    meta: super_45pricebrVDDjzjsdMeta || {},
    component: () => import("/vercel/path0/pages/courses/super-price.vue")
  },
  {
    name: "courses-super-price___fr",
    path: "/fr/courses/super-price",
    meta: super_45pricebrVDDjzjsdMeta || {},
    component: () => import("/vercel/path0/pages/courses/super-price.vue")
  },
  {
    name: "courses-super-price___it",
    path: "/it/courses/super-price",
    meta: super_45pricebrVDDjzjsdMeta || {},
    component: () => import("/vercel/path0/pages/courses/super-price.vue")
  },
  {
    name: "download___en",
    path: "/en/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___es",
    path: "/es/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___es-mx",
    path: "/es-mx/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___pt",
    path: "/pt/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___pt-br",
    path: "/pt-br/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___de",
    path: "/de/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___fr",
    path: "/fr/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___it",
    path: "/it/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "final-page___en",
    path: "/en/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___es",
    path: "/es/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___es-mx",
    path: "/es-mx/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___pt",
    path: "/pt/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___pt-br",
    path: "/pt-br/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___de",
    path: "/de/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___fr",
    path: "/fr/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___it",
    path: "/it/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "fitness-basic-discount___en",
    path: "/en/fitness/basic-discount",
    meta: basic_45discountXhGjgMii2cMeta || {},
    component: () => import("/vercel/path0/pages/fitness/basic-discount.vue")
  },
  {
    name: "fitness-basic-discount___es",
    path: "/es/fitness/basic-discount",
    meta: basic_45discountXhGjgMii2cMeta || {},
    component: () => import("/vercel/path0/pages/fitness/basic-discount.vue")
  },
  {
    name: "fitness-basic-discount___es-mx",
    path: "/es-mx/fitness/basic-discount",
    meta: basic_45discountXhGjgMii2cMeta || {},
    component: () => import("/vercel/path0/pages/fitness/basic-discount.vue")
  },
  {
    name: "fitness-basic-discount___pt",
    path: "/pt/fitness/basic-discount",
    meta: basic_45discountXhGjgMii2cMeta || {},
    component: () => import("/vercel/path0/pages/fitness/basic-discount.vue")
  },
  {
    name: "fitness-basic-discount___pt-br",
    path: "/pt-br/fitness/basic-discount",
    meta: basic_45discountXhGjgMii2cMeta || {},
    component: () => import("/vercel/path0/pages/fitness/basic-discount.vue")
  },
  {
    name: "fitness-basic-discount___de",
    path: "/de/fitness/basic-discount",
    meta: basic_45discountXhGjgMii2cMeta || {},
    component: () => import("/vercel/path0/pages/fitness/basic-discount.vue")
  },
  {
    name: "fitness-basic-discount___fr",
    path: "/fr/fitness/basic-discount",
    meta: basic_45discountXhGjgMii2cMeta || {},
    component: () => import("/vercel/path0/pages/fitness/basic-discount.vue")
  },
  {
    name: "fitness-basic-discount___it",
    path: "/it/fitness/basic-discount",
    meta: basic_45discountXhGjgMii2cMeta || {},
    component: () => import("/vercel/path0/pages/fitness/basic-discount.vue")
  },
  {
    name: "fitness-did-you-know___en",
    path: "/en/fitness/did-you-know",
    meta: did_45you_45knowemkMmqegDoMeta || {},
    component: () => import("/vercel/path0/pages/fitness/did-you-know.vue")
  },
  {
    name: "fitness-did-you-know___es",
    path: "/es/fitness/did-you-know",
    meta: did_45you_45knowemkMmqegDoMeta || {},
    component: () => import("/vercel/path0/pages/fitness/did-you-know.vue")
  },
  {
    name: "fitness-did-you-know___es-mx",
    path: "/es-mx/fitness/did-you-know",
    meta: did_45you_45knowemkMmqegDoMeta || {},
    component: () => import("/vercel/path0/pages/fitness/did-you-know.vue")
  },
  {
    name: "fitness-did-you-know___pt",
    path: "/pt/fitness/did-you-know",
    meta: did_45you_45knowemkMmqegDoMeta || {},
    component: () => import("/vercel/path0/pages/fitness/did-you-know.vue")
  },
  {
    name: "fitness-did-you-know___pt-br",
    path: "/pt-br/fitness/did-you-know",
    meta: did_45you_45knowemkMmqegDoMeta || {},
    component: () => import("/vercel/path0/pages/fitness/did-you-know.vue")
  },
  {
    name: "fitness-did-you-know___de",
    path: "/de/fitness/did-you-know",
    meta: did_45you_45knowemkMmqegDoMeta || {},
    component: () => import("/vercel/path0/pages/fitness/did-you-know.vue")
  },
  {
    name: "fitness-did-you-know___fr",
    path: "/fr/fitness/did-you-know",
    meta: did_45you_45knowemkMmqegDoMeta || {},
    component: () => import("/vercel/path0/pages/fitness/did-you-know.vue")
  },
  {
    name: "fitness-did-you-know___it",
    path: "/it/fitness/did-you-know",
    meta: did_45you_45knowemkMmqegDoMeta || {},
    component: () => import("/vercel/path0/pages/fitness/did-you-know.vue")
  },
  {
    name: "fitness-super-discount___en",
    path: "/en/fitness/super-discount",
    meta: super_45discountuIryNVlQd7Meta || {},
    component: () => import("/vercel/path0/pages/fitness/super-discount.vue")
  },
  {
    name: "fitness-super-discount___es",
    path: "/es/fitness/super-discount",
    meta: super_45discountuIryNVlQd7Meta || {},
    component: () => import("/vercel/path0/pages/fitness/super-discount.vue")
  },
  {
    name: "fitness-super-discount___es-mx",
    path: "/es-mx/fitness/super-discount",
    meta: super_45discountuIryNVlQd7Meta || {},
    component: () => import("/vercel/path0/pages/fitness/super-discount.vue")
  },
  {
    name: "fitness-super-discount___pt",
    path: "/pt/fitness/super-discount",
    meta: super_45discountuIryNVlQd7Meta || {},
    component: () => import("/vercel/path0/pages/fitness/super-discount.vue")
  },
  {
    name: "fitness-super-discount___pt-br",
    path: "/pt-br/fitness/super-discount",
    meta: super_45discountuIryNVlQd7Meta || {},
    component: () => import("/vercel/path0/pages/fitness/super-discount.vue")
  },
  {
    name: "fitness-super-discount___de",
    path: "/de/fitness/super-discount",
    meta: super_45discountuIryNVlQd7Meta || {},
    component: () => import("/vercel/path0/pages/fitness/super-discount.vue")
  },
  {
    name: "fitness-super-discount___fr",
    path: "/fr/fitness/super-discount",
    meta: super_45discountuIryNVlQd7Meta || {},
    component: () => import("/vercel/path0/pages/fitness/super-discount.vue")
  },
  {
    name: "fitness-super-discount___it",
    path: "/it/fitness/super-discount",
    meta: super_45discountuIryNVlQd7Meta || {},
    component: () => import("/vercel/path0/pages/fitness/super-discount.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___es-mx",
    path: "/es-mx",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___pt-br",
    path: "/pt-br",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "landing_email___en",
    path: "/en/landing_email",
    meta: landing_emailIOrt1ZPhFJMeta || {},
    alias: ["/en/landing_ios_v1","/en/landing_ios_v2","/en/landing_ios_v3","/en/landing_ios_v4","/en/landing_ios_v5","/en/landing_android_v1","/en/landing_android_v2","/en/landing_android_v3","/en/landing_android_v4"],
    component: () => import("/vercel/path0/pages/landing_email.vue")
  },
  {
    name: "landing_email___es",
    path: "/es/landing_email",
    meta: landing_emailIOrt1ZPhFJMeta || {},
    alias: ["/es/landing_ios_v1","/es/landing_ios_v2","/es/landing_ios_v3","/es/landing_ios_v4","/es/landing_ios_v5","/es/landing_android_v1","/es/landing_android_v2","/es/landing_android_v3","/es/landing_android_v4"],
    component: () => import("/vercel/path0/pages/landing_email.vue")
  },
  {
    name: "landing_email___es-mx",
    path: "/es-mx/landing_email",
    meta: landing_emailIOrt1ZPhFJMeta || {},
    alias: ["/es-mx/landing_ios_v1","/es-mx/landing_ios_v2","/es-mx/landing_ios_v3","/es-mx/landing_ios_v4","/es-mx/landing_ios_v5","/es-mx/landing_android_v1","/es-mx/landing_android_v2","/es-mx/landing_android_v3","/es-mx/landing_android_v4"],
    component: () => import("/vercel/path0/pages/landing_email.vue")
  },
  {
    name: "landing_email___pt",
    path: "/pt/landing_email",
    meta: landing_emailIOrt1ZPhFJMeta || {},
    alias: ["/pt/landing_ios_v1","/pt/landing_ios_v2","/pt/landing_ios_v3","/pt/landing_ios_v4","/pt/landing_ios_v5","/pt/landing_android_v1","/pt/landing_android_v2","/pt/landing_android_v3","/pt/landing_android_v4"],
    component: () => import("/vercel/path0/pages/landing_email.vue")
  },
  {
    name: "landing_email___pt-br",
    path: "/pt-br/landing_email",
    meta: landing_emailIOrt1ZPhFJMeta || {},
    alias: ["/pt-br/landing_ios_v1","/pt-br/landing_ios_v2","/pt-br/landing_ios_v3","/pt-br/landing_ios_v4","/pt-br/landing_ios_v5","/pt-br/landing_android_v1","/pt-br/landing_android_v2","/pt-br/landing_android_v3","/pt-br/landing_android_v4"],
    component: () => import("/vercel/path0/pages/landing_email.vue")
  },
  {
    name: "landing_email___de",
    path: "/de/landing_email",
    meta: landing_emailIOrt1ZPhFJMeta || {},
    alias: ["/de/landing_ios_v1","/de/landing_ios_v2","/de/landing_ios_v3","/de/landing_ios_v4","/de/landing_ios_v5","/de/landing_android_v1","/de/landing_android_v2","/de/landing_android_v3","/de/landing_android_v4"],
    component: () => import("/vercel/path0/pages/landing_email.vue")
  },
  {
    name: "landing_email___fr",
    path: "/fr/landing_email",
    meta: landing_emailIOrt1ZPhFJMeta || {},
    alias: ["/fr/landing_ios_v1","/fr/landing_ios_v2","/fr/landing_ios_v3","/fr/landing_ios_v4","/fr/landing_ios_v5","/fr/landing_android_v1","/fr/landing_android_v2","/fr/landing_android_v3","/fr/landing_android_v4"],
    component: () => import("/vercel/path0/pages/landing_email.vue")
  },
  {
    name: "landing_email___it",
    path: "/it/landing_email",
    meta: landing_emailIOrt1ZPhFJMeta || {},
    alias: ["/it/landing_ios_v1","/it/landing_ios_v2","/it/landing_ios_v3","/it/landing_ios_v4","/it/landing_ios_v5","/it/landing_android_v1","/it/landing_android_v2","/it/landing_android_v3","/it/landing_android_v4"],
    component: () => import("/vercel/path0/pages/landing_email.vue")
  },
  {
    name: "landing_v12_2___en",
    path: "/en/landing_v12_2",
    meta: landing_v12_2blv1jIyVBfMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12_2.vue")
  },
  {
    name: "landing_v12_2___es",
    path: "/es/landing_v12_2",
    meta: landing_v12_2blv1jIyVBfMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12_2.vue")
  },
  {
    name: "landing_v12_2___es-mx",
    path: "/es-mx/landing_v12_2",
    meta: landing_v12_2blv1jIyVBfMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12_2.vue")
  },
  {
    name: "landing_v12_2___pt",
    path: "/pt/landing_v12_2",
    meta: landing_v12_2blv1jIyVBfMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12_2.vue")
  },
  {
    name: "landing_v12_2___pt-br",
    path: "/pt-br/landing_v12_2",
    meta: landing_v12_2blv1jIyVBfMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12_2.vue")
  },
  {
    name: "landing_v12_2___de",
    path: "/de/landing_v12_2",
    meta: landing_v12_2blv1jIyVBfMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12_2.vue")
  },
  {
    name: "landing_v12_2___fr",
    path: "/fr/landing_v12_2",
    meta: landing_v12_2blv1jIyVBfMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12_2.vue")
  },
  {
    name: "landing_v12_2___it",
    path: "/it/landing_v12_2",
    meta: landing_v12_2blv1jIyVBfMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12_2.vue")
  },
  {
    name: "landing_v12___en",
    path: "/en/landing_v12",
    meta: landing_v126BSrM0XGxvMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12.vue")
  },
  {
    name: "landing_v12___es",
    path: "/es/landing_v12",
    meta: landing_v126BSrM0XGxvMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12.vue")
  },
  {
    name: "landing_v12___es-mx",
    path: "/es-mx/landing_v12",
    meta: landing_v126BSrM0XGxvMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12.vue")
  },
  {
    name: "landing_v12___pt",
    path: "/pt/landing_v12",
    meta: landing_v126BSrM0XGxvMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12.vue")
  },
  {
    name: "landing_v12___pt-br",
    path: "/pt-br/landing_v12",
    meta: landing_v126BSrM0XGxvMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12.vue")
  },
  {
    name: "landing_v12___de",
    path: "/de/landing_v12",
    meta: landing_v126BSrM0XGxvMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12.vue")
  },
  {
    name: "landing_v12___fr",
    path: "/fr/landing_v12",
    meta: landing_v126BSrM0XGxvMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12.vue")
  },
  {
    name: "landing_v12___it",
    path: "/it/landing_v12",
    meta: landing_v126BSrM0XGxvMeta || {},
    component: () => import("/vercel/path0/pages/landing_v12.vue")
  },
  {
    name: "landing-paddle___en",
    path: "/en/landing-paddle",
    meta: landing_45paddlen1Co23q0caMeta || {},
    component: () => import("/vercel/path0/pages/landing-paddle.vue")
  },
  {
    name: "landing-paddle___es",
    path: "/es/landing-paddle",
    meta: landing_45paddlen1Co23q0caMeta || {},
    component: () => import("/vercel/path0/pages/landing-paddle.vue")
  },
  {
    name: "landing-paddle___es-mx",
    path: "/es-mx/landing-paddle",
    meta: landing_45paddlen1Co23q0caMeta || {},
    component: () => import("/vercel/path0/pages/landing-paddle.vue")
  },
  {
    name: "landing-paddle___pt",
    path: "/pt/landing-paddle",
    meta: landing_45paddlen1Co23q0caMeta || {},
    component: () => import("/vercel/path0/pages/landing-paddle.vue")
  },
  {
    name: "landing-paddle___pt-br",
    path: "/pt-br/landing-paddle",
    meta: landing_45paddlen1Co23q0caMeta || {},
    component: () => import("/vercel/path0/pages/landing-paddle.vue")
  },
  {
    name: "landing-paddle___de",
    path: "/de/landing-paddle",
    meta: landing_45paddlen1Co23q0caMeta || {},
    component: () => import("/vercel/path0/pages/landing-paddle.vue")
  },
  {
    name: "landing-paddle___fr",
    path: "/fr/landing-paddle",
    meta: landing_45paddlen1Co23q0caMeta || {},
    component: () => import("/vercel/path0/pages/landing-paddle.vue")
  },
  {
    name: "landing-paddle___it",
    path: "/it/landing-paddle",
    meta: landing_45paddlen1Co23q0caMeta || {},
    component: () => import("/vercel/path0/pages/landing-paddle.vue")
  },
  {
    name: "landing-v16___en",
    path: "/en/landing-v16",
    meta: landing_45v16SFR2UePtQ4Meta || {},
    component: () => import("/vercel/path0/pages/landing-v16.vue")
  },
  {
    name: "landing-v16___es",
    path: "/es/landing-v16",
    meta: landing_45v16SFR2UePtQ4Meta || {},
    component: () => import("/vercel/path0/pages/landing-v16.vue")
  },
  {
    name: "landing-v16___es-mx",
    path: "/es-mx/landing-v16",
    meta: landing_45v16SFR2UePtQ4Meta || {},
    component: () => import("/vercel/path0/pages/landing-v16.vue")
  },
  {
    name: "landing-v16___pt",
    path: "/pt/landing-v16",
    meta: landing_45v16SFR2UePtQ4Meta || {},
    component: () => import("/vercel/path0/pages/landing-v16.vue")
  },
  {
    name: "landing-v16___pt-br",
    path: "/pt-br/landing-v16",
    meta: landing_45v16SFR2UePtQ4Meta || {},
    component: () => import("/vercel/path0/pages/landing-v16.vue")
  },
  {
    name: "landing-v16___de",
    path: "/de/landing-v16",
    meta: landing_45v16SFR2UePtQ4Meta || {},
    component: () => import("/vercel/path0/pages/landing-v16.vue")
  },
  {
    name: "landing-v16___fr",
    path: "/fr/landing-v16",
    meta: landing_45v16SFR2UePtQ4Meta || {},
    component: () => import("/vercel/path0/pages/landing-v16.vue")
  },
  {
    name: "landing-v16___it",
    path: "/it/landing-v16",
    meta: landing_45v16SFR2UePtQ4Meta || {},
    component: () => import("/vercel/path0/pages/landing-v16.vue")
  },
  {
    name: "landing-v17___en",
    path: "/en/landing-v17",
    meta: landing_45v17UdrDpvVFokMeta || {},
    component: () => import("/vercel/path0/pages/landing-v17.vue")
  },
  {
    name: "landing-v17___es",
    path: "/es/landing-v17",
    meta: landing_45v17UdrDpvVFokMeta || {},
    component: () => import("/vercel/path0/pages/landing-v17.vue")
  },
  {
    name: "landing-v17___es-mx",
    path: "/es-mx/landing-v17",
    meta: landing_45v17UdrDpvVFokMeta || {},
    component: () => import("/vercel/path0/pages/landing-v17.vue")
  },
  {
    name: "landing-v17___pt",
    path: "/pt/landing-v17",
    meta: landing_45v17UdrDpvVFokMeta || {},
    component: () => import("/vercel/path0/pages/landing-v17.vue")
  },
  {
    name: "landing-v17___pt-br",
    path: "/pt-br/landing-v17",
    meta: landing_45v17UdrDpvVFokMeta || {},
    component: () => import("/vercel/path0/pages/landing-v17.vue")
  },
  {
    name: "landing-v17___de",
    path: "/de/landing-v17",
    meta: landing_45v17UdrDpvVFokMeta || {},
    component: () => import("/vercel/path0/pages/landing-v17.vue")
  },
  {
    name: "landing-v17___fr",
    path: "/fr/landing-v17",
    meta: landing_45v17UdrDpvVFokMeta || {},
    component: () => import("/vercel/path0/pages/landing-v17.vue")
  },
  {
    name: "landing-v17___it",
    path: "/it/landing-v17",
    meta: landing_45v17UdrDpvVFokMeta || {},
    component: () => import("/vercel/path0/pages/landing-v17.vue")
  },
  {
    name: "landing___en",
    path: "/en/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___es",
    path: "/es/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___es-mx",
    path: "/es-mx/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___pt",
    path: "/pt/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___pt-br",
    path: "/pt-br/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___de",
    path: "/de/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___fr",
    path: "/fr/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___it",
    path: "/it/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "plp-1___en",
    path: "/en/plp-1",
    meta: plp_451LB5Zhf7QHlMeta || {},
    component: () => import("/vercel/path0/pages/plp-1.vue")
  },
  {
    name: "plp-1___es",
    path: "/es/plp-1",
    meta: plp_451LB5Zhf7QHlMeta || {},
    component: () => import("/vercel/path0/pages/plp-1.vue")
  },
  {
    name: "plp-1___es-mx",
    path: "/es-mx/plp-1",
    meta: plp_451LB5Zhf7QHlMeta || {},
    component: () => import("/vercel/path0/pages/plp-1.vue")
  },
  {
    name: "plp-1___pt",
    path: "/pt/plp-1",
    meta: plp_451LB5Zhf7QHlMeta || {},
    component: () => import("/vercel/path0/pages/plp-1.vue")
  },
  {
    name: "plp-1___pt-br",
    path: "/pt-br/plp-1",
    meta: plp_451LB5Zhf7QHlMeta || {},
    component: () => import("/vercel/path0/pages/plp-1.vue")
  },
  {
    name: "plp-1___de",
    path: "/de/plp-1",
    meta: plp_451LB5Zhf7QHlMeta || {},
    component: () => import("/vercel/path0/pages/plp-1.vue")
  },
  {
    name: "plp-1___fr",
    path: "/fr/plp-1",
    meta: plp_451LB5Zhf7QHlMeta || {},
    component: () => import("/vercel/path0/pages/plp-1.vue")
  },
  {
    name: "plp-1___it",
    path: "/it/plp-1",
    meta: plp_451LB5Zhf7QHlMeta || {},
    component: () => import("/vercel/path0/pages/plp-1.vue")
  },
  {
    name: "plp-10___en",
    path: "/en/plp-10",
    meta: plp_4510r3FQPePFHNMeta || {},
    component: () => import("/vercel/path0/pages/plp-10.vue")
  },
  {
    name: "plp-10___es",
    path: "/es/plp-10",
    meta: plp_4510r3FQPePFHNMeta || {},
    component: () => import("/vercel/path0/pages/plp-10.vue")
  },
  {
    name: "plp-10___es-mx",
    path: "/es-mx/plp-10",
    meta: plp_4510r3FQPePFHNMeta || {},
    component: () => import("/vercel/path0/pages/plp-10.vue")
  },
  {
    name: "plp-10___pt",
    path: "/pt/plp-10",
    meta: plp_4510r3FQPePFHNMeta || {},
    component: () => import("/vercel/path0/pages/plp-10.vue")
  },
  {
    name: "plp-10___pt-br",
    path: "/pt-br/plp-10",
    meta: plp_4510r3FQPePFHNMeta || {},
    component: () => import("/vercel/path0/pages/plp-10.vue")
  },
  {
    name: "plp-10___de",
    path: "/de/plp-10",
    meta: plp_4510r3FQPePFHNMeta || {},
    component: () => import("/vercel/path0/pages/plp-10.vue")
  },
  {
    name: "plp-10___fr",
    path: "/fr/plp-10",
    meta: plp_4510r3FQPePFHNMeta || {},
    component: () => import("/vercel/path0/pages/plp-10.vue")
  },
  {
    name: "plp-10___it",
    path: "/it/plp-10",
    meta: plp_4510r3FQPePFHNMeta || {},
    component: () => import("/vercel/path0/pages/plp-10.vue")
  },
  {
    name: "plp-2___en",
    path: "/en/plp-2",
    meta: plp_452zpB1dNhubSMeta || {},
    component: () => import("/vercel/path0/pages/plp-2.vue")
  },
  {
    name: "plp-2___es",
    path: "/es/plp-2",
    meta: plp_452zpB1dNhubSMeta || {},
    component: () => import("/vercel/path0/pages/plp-2.vue")
  },
  {
    name: "plp-2___es-mx",
    path: "/es-mx/plp-2",
    meta: plp_452zpB1dNhubSMeta || {},
    component: () => import("/vercel/path0/pages/plp-2.vue")
  },
  {
    name: "plp-2___pt",
    path: "/pt/plp-2",
    meta: plp_452zpB1dNhubSMeta || {},
    component: () => import("/vercel/path0/pages/plp-2.vue")
  },
  {
    name: "plp-2___pt-br",
    path: "/pt-br/plp-2",
    meta: plp_452zpB1dNhubSMeta || {},
    component: () => import("/vercel/path0/pages/plp-2.vue")
  },
  {
    name: "plp-2___de",
    path: "/de/plp-2",
    meta: plp_452zpB1dNhubSMeta || {},
    component: () => import("/vercel/path0/pages/plp-2.vue")
  },
  {
    name: "plp-2___fr",
    path: "/fr/plp-2",
    meta: plp_452zpB1dNhubSMeta || {},
    component: () => import("/vercel/path0/pages/plp-2.vue")
  },
  {
    name: "plp-2___it",
    path: "/it/plp-2",
    meta: plp_452zpB1dNhubSMeta || {},
    component: () => import("/vercel/path0/pages/plp-2.vue")
  },
  {
    name: "plp-3___en",
    path: "/en/plp-3",
    meta: plp_453RnFwoJCIyzMeta || {},
    component: () => import("/vercel/path0/pages/plp-3.vue")
  },
  {
    name: "plp-3___es",
    path: "/es/plp-3",
    meta: plp_453RnFwoJCIyzMeta || {},
    component: () => import("/vercel/path0/pages/plp-3.vue")
  },
  {
    name: "plp-3___es-mx",
    path: "/es-mx/plp-3",
    meta: plp_453RnFwoJCIyzMeta || {},
    component: () => import("/vercel/path0/pages/plp-3.vue")
  },
  {
    name: "plp-3___pt",
    path: "/pt/plp-3",
    meta: plp_453RnFwoJCIyzMeta || {},
    component: () => import("/vercel/path0/pages/plp-3.vue")
  },
  {
    name: "plp-3___pt-br",
    path: "/pt-br/plp-3",
    meta: plp_453RnFwoJCIyzMeta || {},
    component: () => import("/vercel/path0/pages/plp-3.vue")
  },
  {
    name: "plp-3___de",
    path: "/de/plp-3",
    meta: plp_453RnFwoJCIyzMeta || {},
    component: () => import("/vercel/path0/pages/plp-3.vue")
  },
  {
    name: "plp-3___fr",
    path: "/fr/plp-3",
    meta: plp_453RnFwoJCIyzMeta || {},
    component: () => import("/vercel/path0/pages/plp-3.vue")
  },
  {
    name: "plp-3___it",
    path: "/it/plp-3",
    meta: plp_453RnFwoJCIyzMeta || {},
    component: () => import("/vercel/path0/pages/plp-3.vue")
  },
  {
    name: "plp-4___en",
    path: "/en/plp-4",
    meta: plp_454sx2Rvq0KX7Meta || {},
    component: () => import("/vercel/path0/pages/plp-4.vue")
  },
  {
    name: "plp-4___es",
    path: "/es/plp-4",
    meta: plp_454sx2Rvq0KX7Meta || {},
    component: () => import("/vercel/path0/pages/plp-4.vue")
  },
  {
    name: "plp-4___es-mx",
    path: "/es-mx/plp-4",
    meta: plp_454sx2Rvq0KX7Meta || {},
    component: () => import("/vercel/path0/pages/plp-4.vue")
  },
  {
    name: "plp-4___pt",
    path: "/pt/plp-4",
    meta: plp_454sx2Rvq0KX7Meta || {},
    component: () => import("/vercel/path0/pages/plp-4.vue")
  },
  {
    name: "plp-4___pt-br",
    path: "/pt-br/plp-4",
    meta: plp_454sx2Rvq0KX7Meta || {},
    component: () => import("/vercel/path0/pages/plp-4.vue")
  },
  {
    name: "plp-4___de",
    path: "/de/plp-4",
    meta: plp_454sx2Rvq0KX7Meta || {},
    component: () => import("/vercel/path0/pages/plp-4.vue")
  },
  {
    name: "plp-4___fr",
    path: "/fr/plp-4",
    meta: plp_454sx2Rvq0KX7Meta || {},
    component: () => import("/vercel/path0/pages/plp-4.vue")
  },
  {
    name: "plp-4___it",
    path: "/it/plp-4",
    meta: plp_454sx2Rvq0KX7Meta || {},
    component: () => import("/vercel/path0/pages/plp-4.vue")
  },
  {
    name: "plp-5___en",
    path: "/en/plp-5",
    meta: plp_455Z7g56UmEPgMeta || {},
    component: () => import("/vercel/path0/pages/plp-5.vue")
  },
  {
    name: "plp-5___es",
    path: "/es/plp-5",
    meta: plp_455Z7g56UmEPgMeta || {},
    component: () => import("/vercel/path0/pages/plp-5.vue")
  },
  {
    name: "plp-5___es-mx",
    path: "/es-mx/plp-5",
    meta: plp_455Z7g56UmEPgMeta || {},
    component: () => import("/vercel/path0/pages/plp-5.vue")
  },
  {
    name: "plp-5___pt",
    path: "/pt/plp-5",
    meta: plp_455Z7g56UmEPgMeta || {},
    component: () => import("/vercel/path0/pages/plp-5.vue")
  },
  {
    name: "plp-5___pt-br",
    path: "/pt-br/plp-5",
    meta: plp_455Z7g56UmEPgMeta || {},
    component: () => import("/vercel/path0/pages/plp-5.vue")
  },
  {
    name: "plp-5___de",
    path: "/de/plp-5",
    meta: plp_455Z7g56UmEPgMeta || {},
    component: () => import("/vercel/path0/pages/plp-5.vue")
  },
  {
    name: "plp-5___fr",
    path: "/fr/plp-5",
    meta: plp_455Z7g56UmEPgMeta || {},
    component: () => import("/vercel/path0/pages/plp-5.vue")
  },
  {
    name: "plp-5___it",
    path: "/it/plp-5",
    meta: plp_455Z7g56UmEPgMeta || {},
    component: () => import("/vercel/path0/pages/plp-5.vue")
  },
  {
    name: "plp-6___en",
    path: "/en/plp-6",
    meta: plp_45681uqM5EFBJMeta || {},
    component: () => import("/vercel/path0/pages/plp-6.vue")
  },
  {
    name: "plp-6___es",
    path: "/es/plp-6",
    meta: plp_45681uqM5EFBJMeta || {},
    component: () => import("/vercel/path0/pages/plp-6.vue")
  },
  {
    name: "plp-6___es-mx",
    path: "/es-mx/plp-6",
    meta: plp_45681uqM5EFBJMeta || {},
    component: () => import("/vercel/path0/pages/plp-6.vue")
  },
  {
    name: "plp-6___pt",
    path: "/pt/plp-6",
    meta: plp_45681uqM5EFBJMeta || {},
    component: () => import("/vercel/path0/pages/plp-6.vue")
  },
  {
    name: "plp-6___pt-br",
    path: "/pt-br/plp-6",
    meta: plp_45681uqM5EFBJMeta || {},
    component: () => import("/vercel/path0/pages/plp-6.vue")
  },
  {
    name: "plp-6___de",
    path: "/de/plp-6",
    meta: plp_45681uqM5EFBJMeta || {},
    component: () => import("/vercel/path0/pages/plp-6.vue")
  },
  {
    name: "plp-6___fr",
    path: "/fr/plp-6",
    meta: plp_45681uqM5EFBJMeta || {},
    component: () => import("/vercel/path0/pages/plp-6.vue")
  },
  {
    name: "plp-6___it",
    path: "/it/plp-6",
    meta: plp_45681uqM5EFBJMeta || {},
    component: () => import("/vercel/path0/pages/plp-6.vue")
  },
  {
    name: "plp-7___en",
    path: "/en/plp-7",
    meta: plp_457MCRdHMjwLDMeta || {},
    component: () => import("/vercel/path0/pages/plp-7.vue")
  },
  {
    name: "plp-7___es",
    path: "/es/plp-7",
    meta: plp_457MCRdHMjwLDMeta || {},
    component: () => import("/vercel/path0/pages/plp-7.vue")
  },
  {
    name: "plp-7___es-mx",
    path: "/es-mx/plp-7",
    meta: plp_457MCRdHMjwLDMeta || {},
    component: () => import("/vercel/path0/pages/plp-7.vue")
  },
  {
    name: "plp-7___pt",
    path: "/pt/plp-7",
    meta: plp_457MCRdHMjwLDMeta || {},
    component: () => import("/vercel/path0/pages/plp-7.vue")
  },
  {
    name: "plp-7___pt-br",
    path: "/pt-br/plp-7",
    meta: plp_457MCRdHMjwLDMeta || {},
    component: () => import("/vercel/path0/pages/plp-7.vue")
  },
  {
    name: "plp-7___de",
    path: "/de/plp-7",
    meta: plp_457MCRdHMjwLDMeta || {},
    component: () => import("/vercel/path0/pages/plp-7.vue")
  },
  {
    name: "plp-7___fr",
    path: "/fr/plp-7",
    meta: plp_457MCRdHMjwLDMeta || {},
    component: () => import("/vercel/path0/pages/plp-7.vue")
  },
  {
    name: "plp-7___it",
    path: "/it/plp-7",
    meta: plp_457MCRdHMjwLDMeta || {},
    component: () => import("/vercel/path0/pages/plp-7.vue")
  },
  {
    name: "plp-8___en",
    path: "/en/plp-8",
    meta: plp_458kDVKuwNKTQMeta || {},
    component: () => import("/vercel/path0/pages/plp-8.vue")
  },
  {
    name: "plp-8___es",
    path: "/es/plp-8",
    meta: plp_458kDVKuwNKTQMeta || {},
    component: () => import("/vercel/path0/pages/plp-8.vue")
  },
  {
    name: "plp-8___es-mx",
    path: "/es-mx/plp-8",
    meta: plp_458kDVKuwNKTQMeta || {},
    component: () => import("/vercel/path0/pages/plp-8.vue")
  },
  {
    name: "plp-8___pt",
    path: "/pt/plp-8",
    meta: plp_458kDVKuwNKTQMeta || {},
    component: () => import("/vercel/path0/pages/plp-8.vue")
  },
  {
    name: "plp-8___pt-br",
    path: "/pt-br/plp-8",
    meta: plp_458kDVKuwNKTQMeta || {},
    component: () => import("/vercel/path0/pages/plp-8.vue")
  },
  {
    name: "plp-8___de",
    path: "/de/plp-8",
    meta: plp_458kDVKuwNKTQMeta || {},
    component: () => import("/vercel/path0/pages/plp-8.vue")
  },
  {
    name: "plp-8___fr",
    path: "/fr/plp-8",
    meta: plp_458kDVKuwNKTQMeta || {},
    component: () => import("/vercel/path0/pages/plp-8.vue")
  },
  {
    name: "plp-8___it",
    path: "/it/plp-8",
    meta: plp_458kDVKuwNKTQMeta || {},
    component: () => import("/vercel/path0/pages/plp-8.vue")
  },
  {
    name: "plp-9___en",
    path: "/en/plp-9",
    meta: plp_4592ZSYZpAflgMeta || {},
    component: () => import("/vercel/path0/pages/plp-9.vue")
  },
  {
    name: "plp-9___es",
    path: "/es/plp-9",
    meta: plp_4592ZSYZpAflgMeta || {},
    component: () => import("/vercel/path0/pages/plp-9.vue")
  },
  {
    name: "plp-9___es-mx",
    path: "/es-mx/plp-9",
    meta: plp_4592ZSYZpAflgMeta || {},
    component: () => import("/vercel/path0/pages/plp-9.vue")
  },
  {
    name: "plp-9___pt",
    path: "/pt/plp-9",
    meta: plp_4592ZSYZpAflgMeta || {},
    component: () => import("/vercel/path0/pages/plp-9.vue")
  },
  {
    name: "plp-9___pt-br",
    path: "/pt-br/plp-9",
    meta: plp_4592ZSYZpAflgMeta || {},
    component: () => import("/vercel/path0/pages/plp-9.vue")
  },
  {
    name: "plp-9___de",
    path: "/de/plp-9",
    meta: plp_4592ZSYZpAflgMeta || {},
    component: () => import("/vercel/path0/pages/plp-9.vue")
  },
  {
    name: "plp-9___fr",
    path: "/fr/plp-9",
    meta: plp_4592ZSYZpAflgMeta || {},
    component: () => import("/vercel/path0/pages/plp-9.vue")
  },
  {
    name: "plp-9___it",
    path: "/it/plp-9",
    meta: plp_4592ZSYZpAflgMeta || {},
    component: () => import("/vercel/path0/pages/plp-9.vue")
  },
  {
    name: "quiz-id-effective-exercises___en",
    path: "/en/quiz/:id()/effective-exercises",
    meta: effective_45exercisesTnRDLqkrCxMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/effective-exercises.vue")
  },
  {
    name: "quiz-id-effective-exercises___es",
    path: "/es/quiz/:id()/effective-exercises",
    meta: effective_45exercisesTnRDLqkrCxMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/effective-exercises.vue")
  },
  {
    name: "quiz-id-effective-exercises___es-mx",
    path: "/es-mx/quiz/:id()/effective-exercises",
    meta: effective_45exercisesTnRDLqkrCxMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/effective-exercises.vue")
  },
  {
    name: "quiz-id-effective-exercises___pt",
    path: "/pt/quiz/:id()/effective-exercises",
    meta: effective_45exercisesTnRDLqkrCxMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/effective-exercises.vue")
  },
  {
    name: "quiz-id-effective-exercises___pt-br",
    path: "/pt-br/quiz/:id()/effective-exercises",
    meta: effective_45exercisesTnRDLqkrCxMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/effective-exercises.vue")
  },
  {
    name: "quiz-id-effective-exercises___de",
    path: "/de/quiz/:id()/effective-exercises",
    meta: effective_45exercisesTnRDLqkrCxMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/effective-exercises.vue")
  },
  {
    name: "quiz-id-effective-exercises___fr",
    path: "/fr/quiz/:id()/effective-exercises",
    meta: effective_45exercisesTnRDLqkrCxMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/effective-exercises.vue")
  },
  {
    name: "quiz-id-effective-exercises___it",
    path: "/it/quiz/:id()/effective-exercises",
    meta: effective_45exercisesTnRDLqkrCxMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/effective-exercises.vue")
  },
  {
    name: "quiz-id-goals___en",
    path: "/en/quiz/:id()/goals",
    meta: goalsjynoDekJE6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/goals.vue")
  },
  {
    name: "quiz-id-goals___es",
    path: "/es/quiz/:id()/goals",
    meta: goalsjynoDekJE6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/goals.vue")
  },
  {
    name: "quiz-id-goals___es-mx",
    path: "/es-mx/quiz/:id()/goals",
    meta: goalsjynoDekJE6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/goals.vue")
  },
  {
    name: "quiz-id-goals___pt",
    path: "/pt/quiz/:id()/goals",
    meta: goalsjynoDekJE6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/goals.vue")
  },
  {
    name: "quiz-id-goals___pt-br",
    path: "/pt-br/quiz/:id()/goals",
    meta: goalsjynoDekJE6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/goals.vue")
  },
  {
    name: "quiz-id-goals___de",
    path: "/de/quiz/:id()/goals",
    meta: goalsjynoDekJE6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/goals.vue")
  },
  {
    name: "quiz-id-goals___fr",
    path: "/fr/quiz/:id()/goals",
    meta: goalsjynoDekJE6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/goals.vue")
  },
  {
    name: "quiz-id-goals___it",
    path: "/it/quiz/:id()/goals",
    meta: goalsjynoDekJE6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/goals.vue")
  },
  {
    name: "quiz-id-intermediate___en",
    path: "/en/quiz/:id()/intermediate",
    meta: intermediateGirFWSkZOOMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/intermediate.vue")
  },
  {
    name: "quiz-id-intermediate___es",
    path: "/es/quiz/:id()/intermediate",
    meta: intermediateGirFWSkZOOMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/intermediate.vue")
  },
  {
    name: "quiz-id-intermediate___es-mx",
    path: "/es-mx/quiz/:id()/intermediate",
    meta: intermediateGirFWSkZOOMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/intermediate.vue")
  },
  {
    name: "quiz-id-intermediate___pt",
    path: "/pt/quiz/:id()/intermediate",
    meta: intermediateGirFWSkZOOMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/intermediate.vue")
  },
  {
    name: "quiz-id-intermediate___pt-br",
    path: "/pt-br/quiz/:id()/intermediate",
    meta: intermediateGirFWSkZOOMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/intermediate.vue")
  },
  {
    name: "quiz-id-intermediate___de",
    path: "/de/quiz/:id()/intermediate",
    meta: intermediateGirFWSkZOOMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/intermediate.vue")
  },
  {
    name: "quiz-id-intermediate___fr",
    path: "/fr/quiz/:id()/intermediate",
    meta: intermediateGirFWSkZOOMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/intermediate.vue")
  },
  {
    name: "quiz-id-intermediate___it",
    path: "/it/quiz/:id()/intermediate",
    meta: intermediateGirFWSkZOOMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/intermediate.vue")
  },
  {
    name: "quiz-id-kegel-effectiveness___en",
    path: "/en/quiz/:id()/kegel-effectiveness",
    meta: kegel_45effectivenessO202F41S22Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-effectiveness.vue")
  },
  {
    name: "quiz-id-kegel-effectiveness___es",
    path: "/es/quiz/:id()/kegel-effectiveness",
    meta: kegel_45effectivenessO202F41S22Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-effectiveness.vue")
  },
  {
    name: "quiz-id-kegel-effectiveness___es-mx",
    path: "/es-mx/quiz/:id()/kegel-effectiveness",
    meta: kegel_45effectivenessO202F41S22Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-effectiveness.vue")
  },
  {
    name: "quiz-id-kegel-effectiveness___pt",
    path: "/pt/quiz/:id()/kegel-effectiveness",
    meta: kegel_45effectivenessO202F41S22Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-effectiveness.vue")
  },
  {
    name: "quiz-id-kegel-effectiveness___pt-br",
    path: "/pt-br/quiz/:id()/kegel-effectiveness",
    meta: kegel_45effectivenessO202F41S22Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-effectiveness.vue")
  },
  {
    name: "quiz-id-kegel-effectiveness___de",
    path: "/de/quiz/:id()/kegel-effectiveness",
    meta: kegel_45effectivenessO202F41S22Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-effectiveness.vue")
  },
  {
    name: "quiz-id-kegel-effectiveness___fr",
    path: "/fr/quiz/:id()/kegel-effectiveness",
    meta: kegel_45effectivenessO202F41S22Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-effectiveness.vue")
  },
  {
    name: "quiz-id-kegel-effectiveness___it",
    path: "/it/quiz/:id()/kegel-effectiveness",
    meta: kegel_45effectivenessO202F41S22Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-effectiveness.vue")
  },
  {
    name: "quiz-id-kegel-plan-benefits___en",
    path: "/en/quiz/:id()/kegel-plan-benefits",
    meta: kegel_45plan_45benefitsBbKtz11SsPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-plan-benefits.vue")
  },
  {
    name: "quiz-id-kegel-plan-benefits___es",
    path: "/es/quiz/:id()/kegel-plan-benefits",
    meta: kegel_45plan_45benefitsBbKtz11SsPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-plan-benefits.vue")
  },
  {
    name: "quiz-id-kegel-plan-benefits___es-mx",
    path: "/es-mx/quiz/:id()/kegel-plan-benefits",
    meta: kegel_45plan_45benefitsBbKtz11SsPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-plan-benefits.vue")
  },
  {
    name: "quiz-id-kegel-plan-benefits___pt",
    path: "/pt/quiz/:id()/kegel-plan-benefits",
    meta: kegel_45plan_45benefitsBbKtz11SsPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-plan-benefits.vue")
  },
  {
    name: "quiz-id-kegel-plan-benefits___pt-br",
    path: "/pt-br/quiz/:id()/kegel-plan-benefits",
    meta: kegel_45plan_45benefitsBbKtz11SsPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-plan-benefits.vue")
  },
  {
    name: "quiz-id-kegel-plan-benefits___de",
    path: "/de/quiz/:id()/kegel-plan-benefits",
    meta: kegel_45plan_45benefitsBbKtz11SsPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-plan-benefits.vue")
  },
  {
    name: "quiz-id-kegel-plan-benefits___fr",
    path: "/fr/quiz/:id()/kegel-plan-benefits",
    meta: kegel_45plan_45benefitsBbKtz11SsPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-plan-benefits.vue")
  },
  {
    name: "quiz-id-kegel-plan-benefits___it",
    path: "/it/quiz/:id()/kegel-plan-benefits",
    meta: kegel_45plan_45benefitsBbKtz11SsPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/kegel-plan-benefits.vue")
  },
  {
    name: "quiz-id-pp1___en",
    path: "/en/quiz/:id()/pp1",
    meta: pp1iP6bVcUzwVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pp1.vue")
  },
  {
    name: "quiz-id-pp1___es",
    path: "/es/quiz/:id()/pp1",
    meta: pp1iP6bVcUzwVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pp1.vue")
  },
  {
    name: "quiz-id-pp1___es-mx",
    path: "/es-mx/quiz/:id()/pp1",
    meta: pp1iP6bVcUzwVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pp1.vue")
  },
  {
    name: "quiz-id-pp1___pt",
    path: "/pt/quiz/:id()/pp1",
    meta: pp1iP6bVcUzwVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pp1.vue")
  },
  {
    name: "quiz-id-pp1___pt-br",
    path: "/pt-br/quiz/:id()/pp1",
    meta: pp1iP6bVcUzwVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pp1.vue")
  },
  {
    name: "quiz-id-pp1___de",
    path: "/de/quiz/:id()/pp1",
    meta: pp1iP6bVcUzwVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pp1.vue")
  },
  {
    name: "quiz-id-pp1___fr",
    path: "/fr/quiz/:id()/pp1",
    meta: pp1iP6bVcUzwVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pp1.vue")
  },
  {
    name: "quiz-id-pp1___it",
    path: "/it/quiz/:id()/pp1",
    meta: pp1iP6bVcUzwVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pp1.vue")
  },
  {
    name: "quiz-id-question___en",
    path: "/en/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___es",
    path: "/es/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___es-mx",
    path: "/es-mx/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___pt",
    path: "/pt/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___pt-br",
    path: "/pt-br/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___de",
    path: "/de/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___fr",
    path: "/fr/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___it",
    path: "/it/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-rate___en",
    path: "/en/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___es",
    path: "/es/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___es-mx",
    path: "/es-mx/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___pt",
    path: "/pt/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___pt-br",
    path: "/pt-br/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___de",
    path: "/de/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___fr",
    path: "/fr/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___it",
    path: "/it/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-s1___en",
    path: "/en/quiz/:id()/s1",
    meta: s1Entsh68v4cMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/s1.vue")
  },
  {
    name: "quiz-id-s1___es",
    path: "/es/quiz/:id()/s1",
    meta: s1Entsh68v4cMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/s1.vue")
  },
  {
    name: "quiz-id-s1___es-mx",
    path: "/es-mx/quiz/:id()/s1",
    meta: s1Entsh68v4cMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/s1.vue")
  },
  {
    name: "quiz-id-s1___pt",
    path: "/pt/quiz/:id()/s1",
    meta: s1Entsh68v4cMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/s1.vue")
  },
  {
    name: "quiz-id-s1___pt-br",
    path: "/pt-br/quiz/:id()/s1",
    meta: s1Entsh68v4cMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/s1.vue")
  },
  {
    name: "quiz-id-s1___de",
    path: "/de/quiz/:id()/s1",
    meta: s1Entsh68v4cMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/s1.vue")
  },
  {
    name: "quiz-id-s1___fr",
    path: "/fr/quiz/:id()/s1",
    meta: s1Entsh68v4cMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/s1.vue")
  },
  {
    name: "quiz-id-s1___it",
    path: "/it/quiz/:id()/s1",
    meta: s1Entsh68v4cMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/s1.vue")
  },
  {
    name: "quiz-id-score-rate___en",
    path: "/en/quiz/:id()/score-rate",
    meta: score_45ratePvr81gx3DnMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/score-rate.vue")
  },
  {
    name: "quiz-id-score-rate___es",
    path: "/es/quiz/:id()/score-rate",
    meta: score_45ratePvr81gx3DnMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/score-rate.vue")
  },
  {
    name: "quiz-id-score-rate___es-mx",
    path: "/es-mx/quiz/:id()/score-rate",
    meta: score_45ratePvr81gx3DnMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/score-rate.vue")
  },
  {
    name: "quiz-id-score-rate___pt",
    path: "/pt/quiz/:id()/score-rate",
    meta: score_45ratePvr81gx3DnMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/score-rate.vue")
  },
  {
    name: "quiz-id-score-rate___pt-br",
    path: "/pt-br/quiz/:id()/score-rate",
    meta: score_45ratePvr81gx3DnMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/score-rate.vue")
  },
  {
    name: "quiz-id-score-rate___de",
    path: "/de/quiz/:id()/score-rate",
    meta: score_45ratePvr81gx3DnMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/score-rate.vue")
  },
  {
    name: "quiz-id-score-rate___fr",
    path: "/fr/quiz/:id()/score-rate",
    meta: score_45ratePvr81gx3DnMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/score-rate.vue")
  },
  {
    name: "quiz-id-score-rate___it",
    path: "/it/quiz/:id()/score-rate",
    meta: score_45ratePvr81gx3DnMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/score-rate.vue")
  },
  {
    name: "quiz-analyzing-answers___en",
    path: "/en/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___es",
    path: "/es/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___es-mx",
    path: "/es-mx/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___pt",
    path: "/pt/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___pt-br",
    path: "/pt-br/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___de",
    path: "/de/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___fr",
    path: "/fr/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___it",
    path: "/it/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-creating-plan___en",
    path: "/en/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___es",
    path: "/es/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___es-mx",
    path: "/es-mx/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___pt",
    path: "/pt/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___pt-br",
    path: "/pt-br/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___de",
    path: "/de/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___fr",
    path: "/fr/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___it",
    path: "/it/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-final-adjustment-v3___en",
    path: "/en/quiz/final-adjustment-v3",
    meta: final_45adjustment_45v3GUylvFiVRqMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment-v3.vue")
  },
  {
    name: "quiz-final-adjustment-v3___es",
    path: "/es/quiz/final-adjustment-v3",
    meta: final_45adjustment_45v3GUylvFiVRqMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment-v3.vue")
  },
  {
    name: "quiz-final-adjustment-v3___es-mx",
    path: "/es-mx/quiz/final-adjustment-v3",
    meta: final_45adjustment_45v3GUylvFiVRqMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment-v3.vue")
  },
  {
    name: "quiz-final-adjustment-v3___pt",
    path: "/pt/quiz/final-adjustment-v3",
    meta: final_45adjustment_45v3GUylvFiVRqMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment-v3.vue")
  },
  {
    name: "quiz-final-adjustment-v3___pt-br",
    path: "/pt-br/quiz/final-adjustment-v3",
    meta: final_45adjustment_45v3GUylvFiVRqMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment-v3.vue")
  },
  {
    name: "quiz-final-adjustment-v3___de",
    path: "/de/quiz/final-adjustment-v3",
    meta: final_45adjustment_45v3GUylvFiVRqMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment-v3.vue")
  },
  {
    name: "quiz-final-adjustment-v3___fr",
    path: "/fr/quiz/final-adjustment-v3",
    meta: final_45adjustment_45v3GUylvFiVRqMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment-v3.vue")
  },
  {
    name: "quiz-final-adjustment-v3___it",
    path: "/it/quiz/final-adjustment-v3",
    meta: final_45adjustment_45v3GUylvFiVRqMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment-v3.vue")
  },
  {
    name: "quiz-final-adjustment___en",
    path: "/en/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___es",
    path: "/es/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___es-mx",
    path: "/es-mx/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___pt",
    path: "/pt/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___pt-br",
    path: "/pt-br/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___de",
    path: "/de/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___fr",
    path: "/fr/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___it",
    path: "/it/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-health-onboarding___en",
    path: "/en/quiz/health-onboarding",
    component: () => import("/vercel/path0/pages/quiz/health-onboarding.vue")
  },
  {
    name: "quiz-health-onboarding___es",
    path: "/es/quiz/health-onboarding",
    component: () => import("/vercel/path0/pages/quiz/health-onboarding.vue")
  },
  {
    name: "quiz-health-onboarding___es-mx",
    path: "/es-mx/quiz/health-onboarding",
    component: () => import("/vercel/path0/pages/quiz/health-onboarding.vue")
  },
  {
    name: "quiz-health-onboarding___pt",
    path: "/pt/quiz/health-onboarding",
    component: () => import("/vercel/path0/pages/quiz/health-onboarding.vue")
  },
  {
    name: "quiz-health-onboarding___pt-br",
    path: "/pt-br/quiz/health-onboarding",
    component: () => import("/vercel/path0/pages/quiz/health-onboarding.vue")
  },
  {
    name: "quiz-health-onboarding___de",
    path: "/de/quiz/health-onboarding",
    component: () => import("/vercel/path0/pages/quiz/health-onboarding.vue")
  },
  {
    name: "quiz-health-onboarding___fr",
    path: "/fr/quiz/health-onboarding",
    component: () => import("/vercel/path0/pages/quiz/health-onboarding.vue")
  },
  {
    name: "quiz-health-onboarding___it",
    path: "/it/quiz/health-onboarding",
    component: () => import("/vercel/path0/pages/quiz/health-onboarding.vue")
  },
  {
    name: "quiz-help-improve___en",
    path: "/en/quiz/help-improve",
    component: () => import("/vercel/path0/pages/quiz/help-improve.vue")
  },
  {
    name: "quiz-help-improve___es",
    path: "/es/quiz/help-improve",
    component: () => import("/vercel/path0/pages/quiz/help-improve.vue")
  },
  {
    name: "quiz-help-improve___es-mx",
    path: "/es-mx/quiz/help-improve",
    component: () => import("/vercel/path0/pages/quiz/help-improve.vue")
  },
  {
    name: "quiz-help-improve___pt",
    path: "/pt/quiz/help-improve",
    component: () => import("/vercel/path0/pages/quiz/help-improve.vue")
  },
  {
    name: "quiz-help-improve___pt-br",
    path: "/pt-br/quiz/help-improve",
    component: () => import("/vercel/path0/pages/quiz/help-improve.vue")
  },
  {
    name: "quiz-help-improve___de",
    path: "/de/quiz/help-improve",
    component: () => import("/vercel/path0/pages/quiz/help-improve.vue")
  },
  {
    name: "quiz-help-improve___fr",
    path: "/fr/quiz/help-improve",
    component: () => import("/vercel/path0/pages/quiz/help-improve.vue")
  },
  {
    name: "quiz-help-improve___it",
    path: "/it/quiz/help-improve",
    component: () => import("/vercel/path0/pages/quiz/help-improve.vue")
  },
  {
    name: "quiz-score-onboarding___en",
    path: "/en/quiz/score-onboarding",
    component: () => import("/vercel/path0/pages/quiz/score-onboarding.vue")
  },
  {
    name: "quiz-score-onboarding___es",
    path: "/es/quiz/score-onboarding",
    component: () => import("/vercel/path0/pages/quiz/score-onboarding.vue")
  },
  {
    name: "quiz-score-onboarding___es-mx",
    path: "/es-mx/quiz/score-onboarding",
    component: () => import("/vercel/path0/pages/quiz/score-onboarding.vue")
  },
  {
    name: "quiz-score-onboarding___pt",
    path: "/pt/quiz/score-onboarding",
    component: () => import("/vercel/path0/pages/quiz/score-onboarding.vue")
  },
  {
    name: "quiz-score-onboarding___pt-br",
    path: "/pt-br/quiz/score-onboarding",
    component: () => import("/vercel/path0/pages/quiz/score-onboarding.vue")
  },
  {
    name: "quiz-score-onboarding___de",
    path: "/de/quiz/score-onboarding",
    component: () => import("/vercel/path0/pages/quiz/score-onboarding.vue")
  },
  {
    name: "quiz-score-onboarding___fr",
    path: "/fr/quiz/score-onboarding",
    component: () => import("/vercel/path0/pages/quiz/score-onboarding.vue")
  },
  {
    name: "quiz-score-onboarding___it",
    path: "/it/quiz/score-onboarding",
    component: () => import("/vercel/path0/pages/quiz/score-onboarding.vue")
  },
  {
    name: "quiz-score-your-result___en",
    path: "/en/quiz/score-your-result",
    component: () => import("/vercel/path0/pages/quiz/score-your-result.vue")
  },
  {
    name: "quiz-score-your-result___es",
    path: "/es/quiz/score-your-result",
    component: () => import("/vercel/path0/pages/quiz/score-your-result.vue")
  },
  {
    name: "quiz-score-your-result___es-mx",
    path: "/es-mx/quiz/score-your-result",
    component: () => import("/vercel/path0/pages/quiz/score-your-result.vue")
  },
  {
    name: "quiz-score-your-result___pt",
    path: "/pt/quiz/score-your-result",
    component: () => import("/vercel/path0/pages/quiz/score-your-result.vue")
  },
  {
    name: "quiz-score-your-result___pt-br",
    path: "/pt-br/quiz/score-your-result",
    component: () => import("/vercel/path0/pages/quiz/score-your-result.vue")
  },
  {
    name: "quiz-score-your-result___de",
    path: "/de/quiz/score-your-result",
    component: () => import("/vercel/path0/pages/quiz/score-your-result.vue")
  },
  {
    name: "quiz-score-your-result___fr",
    path: "/fr/quiz/score-your-result",
    component: () => import("/vercel/path0/pages/quiz/score-your-result.vue")
  },
  {
    name: "quiz-score-your-result___it",
    path: "/it/quiz/score-your-result",
    component: () => import("/vercel/path0/pages/quiz/score-your-result.vue")
  },
  {
    name: "quiz-the-best-thing___en",
    path: "/en/quiz/the-best-thing",
    component: () => import("/vercel/path0/pages/quiz/the-best-thing.vue")
  },
  {
    name: "quiz-the-best-thing___es",
    path: "/es/quiz/the-best-thing",
    component: () => import("/vercel/path0/pages/quiz/the-best-thing.vue")
  },
  {
    name: "quiz-the-best-thing___es-mx",
    path: "/es-mx/quiz/the-best-thing",
    component: () => import("/vercel/path0/pages/quiz/the-best-thing.vue")
  },
  {
    name: "quiz-the-best-thing___pt",
    path: "/pt/quiz/the-best-thing",
    component: () => import("/vercel/path0/pages/quiz/the-best-thing.vue")
  },
  {
    name: "quiz-the-best-thing___pt-br",
    path: "/pt-br/quiz/the-best-thing",
    component: () => import("/vercel/path0/pages/quiz/the-best-thing.vue")
  },
  {
    name: "quiz-the-best-thing___de",
    path: "/de/quiz/the-best-thing",
    component: () => import("/vercel/path0/pages/quiz/the-best-thing.vue")
  },
  {
    name: "quiz-the-best-thing___fr",
    path: "/fr/quiz/the-best-thing",
    component: () => import("/vercel/path0/pages/quiz/the-best-thing.vue")
  },
  {
    name: "quiz-the-best-thing___it",
    path: "/it/quiz/the-best-thing",
    component: () => import("/vercel/path0/pages/quiz/the-best-thing.vue")
  },
  {
    name: "quiz-trusted___en",
    path: "/en/quiz/trusted",
    component: () => import("/vercel/path0/pages/quiz/trusted.vue")
  },
  {
    name: "quiz-trusted___es",
    path: "/es/quiz/trusted",
    component: () => import("/vercel/path0/pages/quiz/trusted.vue")
  },
  {
    name: "quiz-trusted___es-mx",
    path: "/es-mx/quiz/trusted",
    component: () => import("/vercel/path0/pages/quiz/trusted.vue")
  },
  {
    name: "quiz-trusted___pt",
    path: "/pt/quiz/trusted",
    component: () => import("/vercel/path0/pages/quiz/trusted.vue")
  },
  {
    name: "quiz-trusted___pt-br",
    path: "/pt-br/quiz/trusted",
    component: () => import("/vercel/path0/pages/quiz/trusted.vue")
  },
  {
    name: "quiz-trusted___de",
    path: "/de/quiz/trusted",
    component: () => import("/vercel/path0/pages/quiz/trusted.vue")
  },
  {
    name: "quiz-trusted___fr",
    path: "/fr/quiz/trusted",
    component: () => import("/vercel/path0/pages/quiz/trusted.vue")
  },
  {
    name: "quiz-trusted___it",
    path: "/it/quiz/trusted",
    component: () => import("/vercel/path0/pages/quiz/trusted.vue")
  },
  {
    name: "score___en",
    path: "/en/score",
    meta: indexDq5y7eD1iXMeta || {},
    component: () => import("/vercel/path0/pages/score/index.vue")
  },
  {
    name: "score___es",
    path: "/es/score",
    meta: indexDq5y7eD1iXMeta || {},
    component: () => import("/vercel/path0/pages/score/index.vue")
  },
  {
    name: "score___es-mx",
    path: "/es-mx/score",
    meta: indexDq5y7eD1iXMeta || {},
    component: () => import("/vercel/path0/pages/score/index.vue")
  },
  {
    name: "score___pt",
    path: "/pt/score",
    meta: indexDq5y7eD1iXMeta || {},
    component: () => import("/vercel/path0/pages/score/index.vue")
  },
  {
    name: "score___pt-br",
    path: "/pt-br/score",
    meta: indexDq5y7eD1iXMeta || {},
    component: () => import("/vercel/path0/pages/score/index.vue")
  },
  {
    name: "score___de",
    path: "/de/score",
    meta: indexDq5y7eD1iXMeta || {},
    component: () => import("/vercel/path0/pages/score/index.vue")
  },
  {
    name: "score___fr",
    path: "/fr/score",
    meta: indexDq5y7eD1iXMeta || {},
    component: () => import("/vercel/path0/pages/score/index.vue")
  },
  {
    name: "score___it",
    path: "/it/score",
    meta: indexDq5y7eD1iXMeta || {},
    component: () => import("/vercel/path0/pages/score/index.vue")
  },
  {
    name: "verify-email___en",
    path: "/en/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___es",
    path: "/es/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___es-mx",
    path: "/es-mx/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___pt",
    path: "/pt/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___pt-br",
    path: "/pt-br/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___de",
    path: "/de/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___fr",
    path: "/fr/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___it",
    path: "/it/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  }
]